// extracted by mini-css-extract-plugin
export default {"projects-wrapper":"projects_projects-wrapper__RyHKD","project-content":"projects_project-content__GJlvw"};